<template>
  <div class="pop">
    <div class="popover-tag" @click.stop="pop($event)">
      <slot ref="slot" />
    </div>
    <div
      class="popover-wrap"
      :style="{
        visibility: show ? 'visible' : 'hidden'
      }"
      ref="pop"
    >
      <div class="popover-box">
        <div class="popover-effe">
          <div class="popover-title">
            规则说明：
          </div>
          <div class="popover-cont">
            <p>1.本月使用达标后，优惠券将在次月10号前发放完成；</p>
            <p>2.请确保提前绑定药帮忙，否则达标后无法返券；</p>
            <p>3.因未绑定药帮忙账号导致返券失败，不会扣减返券次数；</p>
            <p>4.因未绑定药帮忙账号导致返券失败，不会补发；</p>
            <p>
              5.请在每月4号前将收银端上个月的订单及时上传，否则未上传订单将不计入统计。
            </p>
          </div>
        </div>

        <div class="popover-arrow popover-arrow-top" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: "标题"
    },
    content: {
      type: String,
      default: "内容"
    },
    placement: {
      type: String,
      default: "top"
    }
  },
  data() {
    return {
      show: false,
      arrowLeft: 0,
      x: 0,
      y: 0
    }
  },
  created() {
    document.body.addEventListener("touchstart", this.closeShow, true)
  },
  destroyed() {
    document.body.removeEventListener("touchstart", this.closeShow, true)
  },
  methods: {
    pop(e) {
      if (this.show) {
        this.show = false
        return
      }
      this.show = true
    },
    closeShow(e) {
      if (this.$slots && this.$slots.default) {
        if (e.target !== this.$slots.default[0].elm) {
          this.show = false
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
.pop {
  position: relative;
  display: inline-block;
  .popover-wrap {
    position: relative;
    z-index: 9999;
    left: -120px;
    top: 7px;
    .popover-box {
      border-radius: 2%;
      background: #ffffff;
      width: 326px;
      height: 168px;
      position: absolute;
      box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.09);
      .popover-effe {
        font-size: 12px;
        margin: 10px 3px 0 6px;
        font-weight: 400;
        color: #343d54;
        .popover-title {
          font-family: PingFangSC-Medium, PingFang SC;
          font-size: 14px;
          margin-bottom: 4px;
          color: #343d54;
          line-height: 20px;
        }
        .popover-cont {
          p {
            font-family: PingFangSC-Regular, PingFang SC;
            margin-bottom: 4px;
            margin-top: 0;
            font-size: 12px;
            color: #343d54;
            height: 17px;
            line-height: 17px;
          }
        }
      }
      .popover-arrow {
        position: absolute;
        left: 136px;
        border: 7px solid transparent;
        border-top-width: 0;
        border-bottom-color: #ffffff;
        top: -5px;
      }
    }
  }
}
</style>
